/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import * as status from "../LeadStatus/StatusBasicCase";

const STAGE_CREATED = 10;
const STAGE_COMPLETED = 200;

export { STAGE_CREATED, STAGE_COMPLETED };

export const stageMetaDataPendingCase = {
  [STAGE_CREATED]: {
    label: "Daten befüllt",
    stage: STAGE_CREATED,
    leadStatus: status.STATUS_CREATED,
    isActive: () => true,
    isClickable: () => false,
    showInBoard: false,
  },
  [STAGE_COMPLETED]: {
    label: "Abgeschlossen",
    stage: STAGE_COMPLETED,
    leadStatus: status.STATUS_COMPLETED,
    isActive: () => true,
    isClickable: () => true,
    showInBoard: true,
  },
};
